(function () {
  function parseJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'PHP'
    });
  }

  function variantForValue(variants, value) {
    var normalized = String(value || '').toLowerCase();
    return variants.find(function (variant) {
      return [variant.option1, variant.option2, variant.option3].some(function (option) {
        return String(option || '').toLowerCase() === normalized;
      });
    });
  }

  function normalizeVariantSizeLabel(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .replace(/(\d)\s+(ml|g|oz)\b/gi, '$1$2')
      .toUpperCase();
  }

  function formatVariantTitle(variant, fallback) {
    if (!variant) return fallback || '';
    var title = variant.public_title || variant.title || fallback || '';
    if (title === 'Default Title') return '';

    if (title.indexOf('/') > -1) {
      var titleParts = title.split('/');
      var variantSize = normalizeVariantSizeLabel(titleParts.shift() || '');
      var descriptor = titleParts.join('/').trim() || 'Parfum';
      return variantSize ? variantSize + ' / ' + descriptor : descriptor;
    }

    var normalizedTitle = normalizeVariantSizeLabel(title);
    return normalizedTitle ? normalizedTitle + ' / Parfum' : '';
  }

  function initProduct(root) {
    if (!root || root.dataset.ladiAuraReady === 'true') return;
    root.dataset.ladiAuraReady = 'true';

    var form = root.querySelector('.product-single__form');
    var variants = parseJson(root.querySelector('[data-ladi-aura-variants]'), []);
    var moneyFormat = parseJson(root.querySelector('[data-ladi-aura-money-format]'), '${{amount}}');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-size-input]'));
    var select = root.querySelector('[data-ladi-aura-variant-select]');
    var price = root.querySelector('[data-ladi-aura-price]');
    var comparePrice = root.querySelector('[data-compare-price]');
    var compareWrap = root.querySelector('[data-product-price-wrap]');
    var variantLine = root.querySelector('[data-ladi-aura-variant-line]');
    var submit = root.querySelector('[data-add-to-cart]');
    var submitText = root.querySelector('[data-add-to-cart-text]');
    var defaultText = submitText ? submitText.dataset.defaultText || submitText.textContent.trim() : 'Add Aura to cart';

    if (form && window.theme && typeof window.theme.AjaxProduct === 'function' && form.dataset.ladiAuraAjaxProduct !== 'true') {
      new window.theme.AjaxProduct(form);
      form.dataset.ladiAuraAjaxProduct = 'true';
    }

    function syncVariant(value) {
      var variant = variantForValue(variants, value);
      if (!variant) return;

      if (select) {
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (price) price.textContent = formatMoney(variant.price, moneyFormat);

      if (comparePrice && compareWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareWrap.classList.remove('hide');
        } else {
          comparePrice.textContent = '';
          compareWrap.classList.add('hide');
        }
      }

      var formattedVariantTitle = formatVariantTitle(variant, value);

      if (variantLine) {
        variantLine.textContent = formattedVariantTitle;
        variantLine.classList.toggle('hide', !variantLine.textContent);
      }

      if (submit && submitText) {
        submit.disabled = !variant.available;
        submitText.textContent = variant.available ? defaultText : 'Sold out';
      }

      root.dispatchEvent(new CustomEvent('variantChange', { detail: { variant: variant }, bubbles: true }));
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) syncVariant(radio.value);
      });
    });

    var checked = root.querySelector('[data-ladi-aura-size-input]:checked');
    if (checked) syncVariant(checked.value);
  }

  function initC02(root) {
    var carousel = root.querySelector('[data-ladi-aura-c02-carousel]');
    var slides = carousel ? Array.prototype.slice.call(carousel.querySelectorAll('[data-ladi-aura-c02-slide]')) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-c02-dot]'));
    var lightbox = root.querySelector('[data-ladi-aura-c02-lightbox]');
    var lightboxImage = root.querySelector('[data-ladi-aura-c02-lightbox-image]');
    var close = root.querySelector('[data-ladi-aura-c02-lightbox-close]');

    function setDot(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    if (carousel && slides.length) {
      carousel.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          var closest = 0;
          var distance = Infinity;
          slides.forEach(function (slide, index) {
            var nextDistance = Math.abs(slide.offsetLeft - carousel.scrollLeft);
            if (nextDistance < distance) {
              distance = nextDistance;
              closest = index;
            }
          });
          setDot(closest);
        });
      }, { passive: true });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.index, 10) || 0;
          if (!slides[index]) return;
          carousel.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
          setDot(index);
        });
      });
    }

    root.querySelectorAll('[data-ladi-aura-c02-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (!lightbox || !lightboxImage) return;
        lightboxImage.src = trigger.dataset.ladiAuraC02LightboxSrc || '';
        lightboxImage.alt = trigger.dataset.ladiAuraC02LightboxAlt || '';
        lightboxImage.width = trigger.dataset.ladiAuraC02LightboxWidth || 1800;
        lightboxImage.height = trigger.dataset.ladiAuraC02LightboxHeight || 1800;
        lightbox.hidden = false;
        document.documentElement.classList.add('ladi-aura-modal-open');
      });
    });

    function closeLightbox() {
      if (!lightbox || !lightboxImage) return;
      lightbox.hidden = true;
      lightboxImage.removeAttribute('src');
      document.documentElement.classList.remove('ladi-aura-modal-open');
    }

    if (close) close.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
    }
  }

  function initC04(root) {
    var modal = root.querySelector('[data-ladi-aura-c04-modal]');
    var open = root.querySelector('[data-ladi-aura-c04-open]');
    var closeButtons = root.querySelectorAll('[data-ladi-aura-c04-close]');
    if (!modal || !open) return;

    open.addEventListener('click', function () {
      modal.hidden = false;
      document.documentElement.classList.add('ladi-aura-modal-open');
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        modal.hidden = true;
        document.documentElement.classList.remove('ladi-aura-modal-open');
      });
    });
  }

  function initC06(root) {
    root.querySelectorAll('[data-ladi-aura-c06-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-ladi-aura-c06-item]');
        var panel = item ? item.querySelector('[data-ladi-aura-c06-panel]') : null;
        if (!item || !panel) return;
        var willOpen = item.dataset.open !== 'true';

        root.querySelectorAll('[data-ladi-aura-c06-item]').forEach(function (other) {
          var otherPanel = other.querySelector('[data-ladi-aura-c06-panel]');
          var otherTrigger = other.querySelector('[data-ladi-aura-c06-trigger]');
          other.dataset.open = 'false';
          other.classList.remove('is-open');
          if (otherPanel) otherPanel.hidden = true;
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        item.dataset.open = willOpen ? 'true' : 'false';
        item.classList.toggle('is-open', willOpen);
        panel.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  function initFaq(root) {
    if (!root || root.dataset.ladiAuraFaqReady === 'true') return;
    root.dataset.ladiAuraFaqReady = 'true';

    root.querySelectorAll('[data-ladi-aura-faq-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-ladi-aura-faq-item]');
        var panel = item ? item.querySelector('[data-ladi-aura-faq-panel]') : null;
        if (!item || !panel) return;
        var willOpen = item.dataset.open !== 'true';

        root.querySelectorAll('[data-ladi-aura-faq-item]').forEach(function (other) {
          var otherPanel = other.querySelector('[data-ladi-aura-faq-panel]');
          var otherTrigger = other.querySelector('[data-ladi-aura-faq-trigger]');
          other.dataset.open = 'false';
          other.classList.remove('is-open');
          if (otherPanel) otherPanel.hidden = true;
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        item.dataset.open = willOpen ? 'true' : 'false';
        item.classList.toggle('is-open', willOpen);
        panel.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  function initC08(root) {
    if (!root || root.dataset.ladiAuraC08Ready === 'true') return;
    root.dataset.ladiAuraC08Ready = 'true';

    var viewport = root.querySelector('[data-ladi-aura-c08-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-c08-card]'));
    var prev = root.querySelector('[data-ladi-aura-c08-prev]');
    var next = root.querySelector('[data-ladi-aura-c08-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-c08-dot]'));
    var forms = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-c08-add-form]'));

    function activeIndex() {
      if (!viewport || !cards.length) return 0;
      var center = viewport.scrollLeft + (viewport.clientWidth / 2);
      var index = 0;
      var distance = Infinity;

      cards.forEach(function (card, cardIndex) {
        var cardCenter = card.offsetLeft + (card.clientWidth / 2);
        var nextDistance = Math.abs(cardCenter - center);
        if (nextDistance < distance) {
          distance = nextDistance;
          index = cardIndex;
        }
      });

      return index;
    }

    function updateControls() {
      if (!viewport || !cards.length) return;
      var index = activeIndex();
      var maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);

      if (prev) prev.disabled = viewport.scrollLeft <= 2;
      if (next) next.disabled = viewport.scrollLeft >= maxScroll - 2;

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function scrollToIndex(index) {
      if (!viewport || !cards[index]) return;
      viewport.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollToIndex(Math.max(activeIndex() - 1, 0));
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollToIndex(Math.min(activeIndex() + 1, cards.length - 1));
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToIndex(parseInt(dot.dataset.index, 10) || 0);
      });
    });

    if (viewport) {
      viewport.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateControls);
      }, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    }

    forms.forEach(function (form) {
      if (form.dataset.ladiAuraC08FormReady === 'true') return;
      form.dataset.ladiAuraC08FormReady = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;

        var buttons = Array.prototype.slice.call(root.querySelectorAll('[form="' + form.id + '"]'));
        form.dataset.submitting = 'true';

        buttons.forEach(function (button) {
          if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent.trim();
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = 'Adding...';
        });

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function (data) {
            buttons.forEach(function (button) {
              button.textContent = 'Added';
            });

            form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: data }
            }));

            window.setTimeout(function () {
              buttons.forEach(function (button) {
                button.disabled = false;
                button.removeAttribute('aria-busy');
                button.textContent = button.dataset.defaultLabel || 'Add to wardrobe';
              });
            }, 1200);
          })
          .catch(function (error) {
            form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
              bubbles: true,
              detail: {
                errorMessage: error && (error.description || error.message) ? error.description || error.message : 'Unable to add this scent right now.'
              }
            }));

            if (form.dataset.productUrl) window.location.href = form.dataset.productUrl;
          })
          .finally(function () {
            form.dataset.submitting = 'false';
          });
      });
    });
  }

  function initC07(root) {
    var viewport = root.querySelector('[data-ladi-aura-c07-viewport]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-c07-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ladi-aura-c07-dot]'));
    var prev = root.querySelector('[data-ladi-aura-c07-prev]');
    var next = root.querySelector('[data-ladi-aura-c07-next]');
    var modal = root.querySelector('[data-ladi-aura-c07-modal]');
    var stage = root.querySelector('[data-ladi-aura-c07-stage]');

    function goTo(index) {
      var card = cards[index];
      if (!card || !viewport) return;
      viewport.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
      cards.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10) || 0);
      });
    });

    if (prev) prev.addEventListener('click', function () {
      var current = Math.max(0, cards.findIndex(function (card) { return card.classList.contains('is-active'); }));
      goTo(Math.max(0, current - 1));
    });

    if (next) next.addEventListener('click', function () {
      var current = Math.max(0, cards.findIndex(function (card) { return card.classList.contains('is-active'); }));
      goTo(Math.min(cards.length - 1, current + 1));
    });

    root.querySelectorAll('[data-ladi-aura-c07-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('[data-ladi-aura-c07-card]');
        var template = card ? card.querySelector('[data-ladi-aura-c07-template]') : null;
        if (!modal || !stage || !template) return;
        stage.innerHTML = '';
        stage.appendChild(template.content.cloneNode(true));
        modal.hidden = false;
        document.documentElement.classList.add('ladi-aura-modal-open');
      });
    });

    root.querySelectorAll('[data-ladi-aura-c07-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!modal || !stage) return;
        modal.hidden = true;
        stage.innerHTML = '';
        document.documentElement.classList.remove('ladi-aura-modal-open');
      });
    });
  }

  function getSessionStorageValue(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function setSessionStorageValue(key, value) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function formatCountdown(milliseconds) {
    var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function initFirstOrderOffer(offer) {
    if (!offer || offer.dataset.ladiAuraOfferReady === 'true') return;
    offer.dataset.ladiAuraOfferReady = 'true';

    var countdown = offer.querySelector('[data-ladi-aura-offer-countdown]');
    var support = offer.querySelector('[data-ladi-aura-offer-support]');
    var minutes = parseInt(offer.dataset.offerMinutes, 10);
    var duration = (Number.isFinite(minutes) && minutes > 0 ? minutes : 10) * 60 * 1000;
    var storageKey = offer.dataset.storageKey || 'ladi-aura-first-order-offer-end';
    var storedEnd = parseInt(getSessionStorageValue(storageKey), 10);
    var endTime = Number.isFinite(storedEnd) ? storedEnd : Date.now() + duration;

    if (!Number.isFinite(storedEnd)) {
      setSessionStorageValue(storageKey, String(endTime));
    }

    function completeOffer() {
      if (countdown) countdown.textContent = '00:00';
      if (support) support.textContent = 'Your first-order offer may still be available at checkout.';
      offer.classList.add('is-complete');
    }

    function render() {
      if (!offer.isConnected) {
        if (offer.ladiAuraOfferInterval) window.clearInterval(offer.ladiAuraOfferInterval);
        return;
      }

      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        completeOffer();
        if (offer.ladiAuraOfferInterval) window.clearInterval(offer.ladiAuraOfferInterval);
        return;
      }

      if (countdown) countdown.textContent = formatCountdown(remaining);
    }

    render();
    if (endTime > Date.now()) {
      offer.ladiAuraOfferInterval = window.setInterval(render, 1000);
    }
  }

  function destroyFirstOrderOffers(scope) {
    (scope || document).querySelectorAll('[data-ladi-aura-first-order-offer]').forEach(function (offer) {
      if (offer.ladiAuraOfferInterval) window.clearInterval(offer.ladiAuraOfferInterval);
      delete offer.ladiAuraOfferInterval;
      delete offer.dataset.ladiAuraOfferReady;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ladi-aura-product]').forEach(function (root) {
      initProduct(root);
      initC02(root);
    });
    (scope || document).querySelectorAll('[data-ladi-aura-first-order-offer]').forEach(initFirstOrderOffer);
    (scope || document).querySelectorAll('[data-ladi-aura-c04-root]').forEach(initC04);
    (scope || document).querySelectorAll('[data-ladi-aura-c06-root]').forEach(initC06);
    (scope || document).querySelectorAll('[data-ladi-aura-faq-root]').forEach(initFaq);
    (scope || document).querySelectorAll('[data-ladi-aura-c08-root]').forEach(initC08);
    (scope || document).querySelectorAll('[data-ladi-aura-c07-root]').forEach(initC07);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyFirstOrderOffers(event.target);
  });

  document.addEventListener('recommendations:loaded', function (event) {
    initAll(event.detail && event.detail.section ? event.detail.section : document);
  });
})();
